import { NavLink, Outlet, useParams } from "react-router-dom";
import { useProjectDetail } from "../lib/project-detail";
import { showsPartnerOrigin } from "../lib/project-wizard";

const TABS = [
  { to: "overview", label: "Übersicht" },
  { to: "tracking", label: "Installation" },
  { to: "integrations", label: "Datenquellen" },
  { to: "destinations", label: "Conversion-API" },
  { to: "consent", label: "Consent & Cookies" },
  { to: "import", label: "Import" },
  { to: "quality", label: "Datenqualität" },
  { to: "rules", label: "Approval Rules" },
  { to: "settings", label: "Einstellungen" },
];

export function ProjectDetailLayout() {
  const { id } = useParams();
  const projectId = id ? parseInt(id, 10) : NaN;
  const { data, isLoading, error } = useProjectDetail(projectId);

  return (
    <div className="px-6 py-8">
      <div className="mx-auto max-w-content space-y-6">
        <header>
          <p className="font-mono text-xs uppercase tracking-wider text-text-tertiary">
            Projekt #{id}
          </p>
          <div className="mt-1 flex items-baseline gap-3">
            <h1 className="text-2xl font-semibold tracking-tight text-text-primary">
              {data?.name ?? (isLoading ? "Lade…" : "—")}
            </h1>
            {data?.archivedAt && (
              <span className="inline-flex items-center gap-1.5 rounded-full border border-border-primary px-2 py-0.5 text-xs font-medium text-text-tertiary">
                Archiviert
              </span>
            )}
            {data && !data.archivedAt && (
              <span
                className={`inline-flex items-center gap-1.5 rounded-full px-2 py-0.5 text-xs font-medium ${
                  data.active
                    ? "bg-success-bg text-success"
                    : "bg-bg-tertiary text-text-secondary"
                }`}
              >
                <span
                  className={`h-1.5 w-1.5 rounded-full ${data.active ? "bg-success" : "bg-text-tertiary"}`}
                />
                {data.active ? "Aktiv" : "Pausiert"}
              </span>
            )}
            {data && (
              <span className="inline-flex items-center gap-1.5 rounded-full bg-bg-tertiary px-2 py-0.5 text-xs font-medium text-text-secondary">
                {data.workspace === "marketingabteilung"
                  ? "marketingabteilung.ai"
                  : "Agentur"}
              </span>
            )}
          </div>
          {data?.subdomain && (
            <p className="mt-1 font-mono text-xs text-text-tertiary">
              {data.subdomain}.dhc-track.io
            </p>
          )}
          {data && showsPartnerOrigin(data.workspace) && (
            <p className="mt-1 text-xs text-text-tertiary">
              Angelegt über marketingabteilung.ai am{" "}
              {new Date(data.createdAt).toLocaleDateString("de-DE")}, Mandant{" "}
              {data.externalId ?? "—"}
            </p>
          )}
        </header>

        <nav className="flex gap-1 border-b border-border-primary">
          {TABS.map((t) => (
            <NavLink
              key={t.to}
              to={t.to}
              className={({ isActive }) =>
                `-mb-px border-b-2 px-3 py-2 text-sm font-medium transition-colors ${
                  isActive
                    ? "border-accent text-text-primary"
                    : "border-transparent text-text-secondary hover:text-text-primary"
                }`
              }
            >
              {t.label}
            </NavLink>
          ))}
        </nav>

        {error && (
          <div className="rounded-md border border-danger bg-danger-bg px-4 py-3 text-sm text-text-primary">
            Projekt konnte nicht geladen werden: {(error as Error).message}
          </div>
        )}

        <Outlet context={{ project: data, isLoading, projectId }} />
      </div>
    </div>
  );
}
